import Lottie from "lottie-react";

import shapeAnim from "../../../lottie/shapes.json";

export default function BrightenTab() {
  return (
    <>
      <div className="brighten-tab-wrap tab-wrapper-all">
        <div className="brighten-tab-wrap__text tab-wrapper-all__text">
          <h2>Identity with Essence</h2>
          <p>
            Branding isn’t decoration. It’s the{" "}
            <span>difference between being seen and being remembered.</span>
          </p>
          <h4>Our approach covers:</h4>
          <ul>
            <li>Visual identity and brand guidelines</li>
            <li>Verbal identity, tone of voice, and storytelling</li>
            <li>Website and digital experience design</li>
            <li>Content creation for web, social, and campaigns</li>
          </ul>
          <span>
            Because building recognition is a smart investment, not a luxury.
          </span>
        </div>
        <div className="brighten-tab-wrap__anim tab-wrapper-all__anim">
          <Lottie animationData={shapeAnim} loop={false} />
        </div>
      </div>
    </>
  );
}
